import { TabbedChips } from '@cbhq/cds-web/chips/TabbedChips';

import { useRoutedTabs } from ':cloud/hooks/useRoutedTabs';

/**
 * Represents a chip with routing information.
 */
interface RoutedChip {
  /** Unique identifier for the chip */
  id: string;
  /** Display label for the chip */
  label: string;
  /** Route path for the chip */
  route: string;
}

/**
 * Props for the RoutedTabbedChips component.
 */
interface RoutedTabbedChipsProps {
  /** Array of RoutedChip objects */
  tabs: RoutedChip[];
}

/**
 * Renders a set of tabbed chips that change the URL when clicked.
 * Assumes that the component is rendered within a route that exists in tabs.
 *
 * @param props.tabs - An array of RoutedChip objects defining the chips and their routes
 * @returns A React component that displays routed tabbed chips
 */
export function RoutedTabbedChips({ tabs }: RoutedTabbedChipsProps) {
  const { currentTab, handleChange } = useRoutedTabs(tabs);

  return <TabbedChips value={currentTab.id} tabs={tabs} onChange={handleChange} />;
}
